import { defineComponent, inject, createBlock, openBlock, withCtx, renderSlot, unref, isRef } from "vue";
import _sfc_main$1 from "../core/Tooltip.vue.js";
import { TOOLTIP_OPEN_MODEL_VALUE_KEY } from "../injectionKeys.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TooltipBind",
  props: {
    handleTooltipOpenUpdate: { type: Function },
    usedInDirectives: { type: Boolean },
    open: { type: Boolean },
    defaultOpen: { type: Boolean }
  },
  setup(__props) {
    const props = __props, openModelValue = inject(TOOLTIP_OPEN_MODEL_VALUE_KEY);
    return (_ctx, _cache) => props.usedInDirectives ? (openBlock(), createBlock(_sfc_main$1, {
      key: 0,
      open: props.open,
      "default-open": props.defaultOpen,
      "onUpdate:open": props.handleTooltipOpenUpdate
    }, {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["open", "default-open", "onUpdate:open"])) : (openBlock(), createBlock(_sfc_main$1, {
      key: 1,
      open: unref(openModelValue),
      "onUpdate:open": _cache[0] || (_cache[0] = ($event) => isRef(openModelValue) ? openModelValue.value = $event : null)
    }, {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["open"]));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=TooltipBind.vue.js.map
